// Utility to convert snake_case keys to camelCase
export const toCamelCase = (str: string): string => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

export const camelCaseKeysDeep = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(camelCaseKeysDeep);
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((result, key) => {
      const camelKey = toCamelCase(key);
      result[camelKey] = camelCaseKeysDeep(obj[key]);
      return result;
    }, {} as any);
  }
  return obj;
};
